import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { get_donations_by_donor_id, delete_donation_by_id } from '../api/donations_api';

import '../styles/Transactions.css';

const Donations = ({ donor }) => {
    const [donations, setDonations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchDonations = async () => {
            if (!donor?.id) return;
            setLoading(true);

            try {
                const data = await get_donations_by_donor_id(donor.id);

                // אימות תגובת API + flat למקרה חריג
                const donationsArray = Array.isArray(data) ? data.flat() : [];

                // מיון לפי תאריך (חדש → ישן)
                donationsArray.sort((a, b) => new Date(b.date) - new Date(a.date));

                setDonations(donationsArray);


                // setDonations(donorDonations);
            } catch (err) {
                console.error("טעינת התרומות נכשלה:", err);
                setError('טעינת התרומות נכשלה.');
            } finally {
                setLoading(false);
            }
        };

        fetchDonations();
    }, [donor?.id]);

    if (loading) return <p>טוען את התרומות...</p>;
    if (error) return <p>{error}</p>;

    const handleDelete = async (id) => {
        if (!window.confirm("האם אתה בטוח שברצונך למחוק את התרומה?")) return;

        try {
            await delete_donation_by_id(id);
            setDonations(prevDonations => prevDonations.filter(d => d.id !== id));
        } catch (err) {
            console.error("מחיקת התרומה נכשלה:", err);
            alert("שגיאה במחיקת התרומה.");
        }
    };

    const handleUpdate = (id) => {
        navigate(`/donors/${donor.id}/donations/update/${id}`, {
            state: { donorName: `${donor.first_name} ${donor.last_name}` }
        });
    };

    const paymentMethodMap = {
        credit: "אשראי",
        recurring: "הוראת קבע",
        cash: "מזומן",
        manual: "הזנה ידנית"
    };

    const statusMap = {
        pending: "ממתין",
        success: "הצלחה",
        failed: "כישלון",
    };

    const currencyMap = {
        ILS: "שקל חדש",
        USD: "דולר",
        EUR: "אירו",
    };

    return (
        <div className="transactions-container">
            <h2 className="transactions-title">תרומות</h2>
            {donations.length === 0 ? (
                <p>אין תרומות לתורם זה</p>
            ) : (
                <table className="transactions-table">
                    <thead>
                        <tr>
                            <th>סכום</th>
                            <th>מטבע</th>
                            <th>תאריך</th>
                            <th>אמצעי תשלום</th>
                            <th>מספר תשלומים</th>
                            <th>סטטוס</th>
                            <th>מספר קבלה</th>
                            <th>מספר עסקה</th>
                            <th>הערות</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {donations.map((d) => (
                            <tr key={d.id}>
                                <td>{d.amount}</td>
                                <td>{currencyMap[d.currency] || d.currency || "—"}</td>
                                <td>{new Date(d.date).toLocaleDateString()}</td>
                                <td>{paymentMethodMap[d.paymentMethod] || d.paymentMethod || "—"}</td>
                                <td>{d.installments || "—"}</td>
                                <td>{statusMap[d.status] || d.status || "—"}</td>
                                <td>{d.receipt_id || "—"}</td>
                                <td>{d.providerTransactionId || "—"}</td>
                                <td>{d.notes || "—"}</td>
                                <td className="action-cell">
                                    <button className="icon-btn" title="עדכן" onClick={() => handleUpdate(d.id)}>
                                        <svg viewBox="0 0 24 24" fill="none">
                                            <path d="M12 20h9" strokeWidth="2" />
                                            <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z" strokeWidth="2" />
                                        </svg>
                                    </button>

                                    <button className="icon-btn" title="מחק" onClick={() => handleDelete(d.id)}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M3 5.5H17" />
                                            <path d="M7 5.5V4C7 3.44772 7.44772 3 8 3H12C12.5523 3 13 3.44772 13 4V5.5" />
                                            <path d="M9 8.5V15.5" />
                                            <path d="M11 8.5V15.5" />
                                            <path d="M5 5.5H15L16 17C16 17.5523 15.5523 18 15 18H5C4.44772 18 4 17.5523 4 17L5 5.5Z" />
                                        </svg>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default Donations;
